import { wallet } from '../types';
import { mergeUniqueByValue } from './service_request';

const INITIAL_STATE = {
    error: undefined,
    walletTransactions: [],
    hasReachedWalletListEnd: false,
    ongoingTransaction: null,
    isWithdrawAmountConfirmed: false,
    securityTransaction: null,
    securityTransactionFail: null,
    userWalletDetailsById: {},
    providerBalance: [],
    myWalletDetail: [],
    walletMoneyData: {},
    withdrawFromWalletOtpSent: false,
    userWalletById: {},
    walletFilterList: {}
};

const walletReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case wallet.GET_PROMISED_AMOUNT_SUCCESS:
            return {
                ...state,
                promisedAmount: action.payload.promisedAmount,
                totalEarning: action.payload.totalEarning,
                totalWithdrawn: action.payload.totalWithdrawn,
                totalPaid: action.payload.totalPaid,
            };
        case wallet.GET_WALLET_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                walletTransactions: action.payload,
                hasReachedWalletListEnd: false,
            };

        case wallet.GET_WALLET_NEXT_TRANSACTIONS_SUCCESS:
            const removeDuplicates = (arr) => {
                const { res } = arr.reduce(
                    ({ encountered, res }, el) => {
                        if (!encountered.has(el.scogo_tx_no)) {
                            encountered.add(el.scogo_tx_no);
                            res.push(el);
                        }
                        return { encountered, res };
                    },
                    { encountered: new Set(), res: [] }
                );
                return res;
            };
            const filteredWalletList = removeDuplicates([...state.walletTransactions, ...action.payload]);
            const hasReachedWalletListEnd = action.payload.length === 0;
            return {
                ...state,
                walletTransactions: filteredWalletList,
                hasReachedWalletListEnd: hasReachedWalletListEnd,
            };
        case wallet.WITHDRAW_WALLET_AMOUNT_WEBHOOK_SUCCESS:
            return {
                ...state,
                walletTransactions:
                    state.walletTransactions &&
                    state.walletTransactions.length > 0 &&
                    state.walletTransactions.map((item) => {
                        if (item.scogo_tx_no === action.payload.scogo_tx_no) {
                            item.status = action.payload.status;
                            item.reason = action.payload.reason;
                            item.txStatus = action.payload.txStatus;
                            item.orderStatus = action.payload.orderStatus;
                            return item;
                        } else {
                            return item;
                        }
                    }),
            };
        case wallet.GET_WALLET_DETAILS_SUCCESS:
            return {
                ...state,
                wallet: action.payload,
            };
        case wallet.GET_WALLET_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                walletDetailsById: action.payload,
            };
        case wallet.REMOVE_WALLET_DETAILS_FROM_STORE:
            return {
                ...state,
                walletDetailsById: undefined,
            };

        case wallet.ADD_AMOUNT_TO_WALLET_SUCCESS:
            return {
                ...state,
                ongoingTransaction: action.payload,
            };
        case wallet.CLEAR_ONGOING_TRANSACTIONS_FROM_STORE:
            return {
                ...state,
                ongoingTransaction: INITIAL_STATE.ongoingTransaction,
            };
        case wallet.GET_RECEPIENTS_FILTERED_DATA_SUCCESS:
            return {
                ...state,
                recepientsFilteredData: action.payload,
            };
        case wallet.SET_IS_WITHDRAWAL_AMOUNT_CONFIRMED:
            return {
                ...state,
                isWithdrawAmountConfirmed: action.payload,
            };
        case wallet.PAY_SECURITY_DEPOSIT_SUCCESS:
            return {
                ...state,
                securityTransaction: action.payload,
            };
        case wallet.PAY_SECURITY_DEPOSIT_FAILURE:
            return {
                ...state,
                securityTransactionFail: action.payload,
            };

        case wallet.CLEAR_ONGOING_SECURITY_DEPOSIT_TRANSACTIONS_FROM_STORE:
            return {
                ...state,
                securityTransaction: INITIAL_STATE.securityTransaction,
                securityTransactionFail: INITIAL_STATE.securityTransactionFail,
            };
        case wallet.GET_USER_WALLET_DETAILS_BY_ID_SUCCESS: {
            const { wallet, userId } = action.payload;

            return {
                ...state,
                userWalletDetailsById: { ...state.userWalletDetailsById, [userId]: wallet }
            };
        }

        //----------------------------------------new----------------------------------------



        case wallet.GET_WALLETS_DETAILS_SUCCESS: {
            const data = action.payload;
            return {
                ...state,
                providerBalance: data
            };
        }

        case wallet.CHECK_TRANSACTION_STATUS_SUCCESS: {
            const data = action.payload;
            let list = state.transactionList.data;
            list = list.map((transaction) => {
                if (transaction.id === data.id) {
                    return data;
                }
                return transaction;
            })

            return {
                ...state,
                transactionList: { ...state.transactionList, data: list }
            }
        }

        case wallet.GET_TRANSACTION_LIST_SUCCESS: {
            const { data, page } = action.payload;
            if (page > 1) {
                return {
                    ...state,
                    transactionList: {
                        data: [...state.transactionList.data, ...data.data],
                        metadata: data.metadata
                    }
                };
            } else {
                return {
                    ...state,
                    transactionList: data
                };
            }
        }
        case wallet.ADD_MONEY_TO_WALLET_SUCCESS: {
            const data = action.payload
            return {
                ...state,
                walletMoneyData: data
            }
        }

        case wallet.GET_MY_WALLET_SUCCESS: {
            const data = action.payload;
            return {
                ...state,
                myWalletDetail: data
            };
        }

        case wallet.WITHDRAW_FROM_WALLET_OTP_SUCCESS: {
            return {
                ...state,
                withdrawFromWalletOtpSent: action.payload
            };
        };

        case wallet.GET_USER_WALLET_BY_ID_SUCCESS: {
            const { wallet, userId } = action.payload;
            return {
                ...state,
                userWalletById: {
                    ...state.userWalletById,
                    [userId]: wallet
                }
            };
        }
        case wallet.GET_TRANSACTION_FILTER_LIST_SUCCESS: {
            const { data, q } = action.payload;

            const walletFilterList = state.walletFilterList;

            if (q) {
                return {
                    ...state,
                    walletFilterList: mergeUniqueByValue(walletFilterList, data)
                }
            }

            const status = [
                { key: 'INITIATED', value: 'INITIATED', label: 'Initiated' },
                { key: 'PENDING', value: 'PENDING', label: 'Pending' },
                { key: 'SCHEDULED', value: 'SCHEDULED', label: 'Scheduled' },
                { key: 'PROCESSING', value: 'PROCESSING', label: 'Processing' },
                { key: 'SUCCESS', value: 'SUCCESS', label: 'Success' },
                { key: 'FAILURE', value: 'FAILURE', label: 'Failure' },
                { key: 'REJECTED', value: 'REJECTED', label: 'Rejected' },
            ];

            return {
                ...state,
                walletFilterList: { ...data, status }
            };
        }

        case wallet.PAY_PO_MANUALLY_FAILURE:
        case wallet.ADD_AMOUNT_TO_WALLET_FAILURE:
        case wallet.GET_WALLET_DETAILS_FAILURE:
        case wallet.GET_WALLET_NEXT_TRANSACTIONS_FAILURE:
        case wallet.GET_WALLET_TRANSACTIONS_FAILURE:
        case wallet.GET_PROMISED_AMOUNT_FAILURE:
        case wallet.REQUEST_STATEMENT_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        default:
            return {
                ...state,
            };
    }
};

export default walletReducer;
